"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var MAX_CELL_HEIGHT = exports.MAX_CELL_HEIGHT = 45;
var HEAD_PADDING = exports.HEAD_PADDING = 15;
var MAX_HEAD_CELL_HEIGHT = exports.MAX_HEAD_CELL_HEIGHT = MAX_CELL_HEIGHT + HEAD_PADDING * 2;
var MIN_BODY_HEIGHT = exports.MIN_BODY_HEIGHT = 360;
var BODY_PADDINGS = exports.BODY_PADDINGS = 236;